import { action, makeObservable, observable } from "mobx";
import { WeeklyRotaDetailsViewModel } from "../WeeklyRotaDetail/WeeklyRotaDetailViewModel";

export class MobXManager {
    public _isWeeklyRotaModalOpen: boolean = false;
    public _copyWeeklyData: boolean = false;
    public _successfullyGetWeeklyRota: boolean = false;
    public _weeklyRotaDetailViewModel: WeeklyRotaDetailsViewModel;

    constructor() {
        this._weeklyRotaDetailViewModel = new WeeklyRotaDetailsViewModel();

        makeObservable<MobXManager, "_isWeeklyRotaModalOpen" | "_copyWeeklyData" | "_successfullyGetWeeklyRota" | "_weeklyRotaDetailViewModel">(this, {
            _isWeeklyRotaModalOpen: observable,
            _copyWeeklyData: observable,
            _successfullyGetWeeklyRota: observable,
            _weeklyRotaDetailViewModel: observable,
            setIsWeeklyRotaModalOpen: action,
            setCopyWeeklyData: action,
            setSuccessfullyGetWeeklyRota: action,
        });
    }

    public get isWeeklyRotaModalOpen(): boolean {
        return this._isWeeklyRotaModalOpen;
    }
    public get copyWeeklyData(): boolean {
        return this._copyWeeklyData;
    }
    public get successfullyGetWeeklyRota(): boolean {
        return this._successfullyGetWeeklyRota;
    }
    public get weeklyRotaDetailViewModel(): WeeklyRotaDetailsViewModel {
        return this._weeklyRotaDetailViewModel;
    }

    public setIsWeeklyRotaModalOpen(value: boolean): void {
        this._isWeeklyRotaModalOpen = value;
    }
    public setCopyWeeklyData(value: boolean): void {
        this._copyWeeklyData = value;
    }
    public setSuccessfullyGetWeeklyRota(value: boolean): void {
        this._successfullyGetWeeklyRota = value;
    }
}
